export const FLOW_BUILDER_V1_SEGMENT = 'flow-builder';
export const FLOW_BUILDER_V2_SEGMENT = 'flow-builder-v2';

export function getFlowBuilderPath(
  pid: string,
  id: string,
  { v2 = false, search = '' }: { v2?: boolean; search?: string } = {},
): string {
  const segment = v2 ? FLOW_BUILDER_V2_SEGMENT : FLOW_BUILDER_V1_SEGMENT;
  const base = `/project/${pid}/experiences/${id}/${segment}`;
  return search ? `${base}?${search}` : base;
}
